import {MARKER_START2} from './MarkerStartTypes2'

export const changeMarkerStart2 = markerStart2 => {
    return {
        type: MARKER_START2,
        load: markerStart2
    }
}

export const selectNewMarkerStart2 = (markerStart2) => {

    return (dispatch) => {
        
        dispatch(changeMarkerStart2(markerStart2))
    }

}